import React from "react";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { CreditCard } from "react-feather";
import { paths } from "../../../../routes/paths";
import { useCollectionsRecords } from "../../useCollectionsRecords";
import { money } from "../../dashboardHelpers";
import { useBranchFilter } from "../../../branchFilter/useBranchFilter";

// Independent of the global period picker - always "today", same as
// Flutter's own _ChequesDueTodayCard (cheques due today matter regardless
// of what date range the rest of the dashboard is currently showing).
// Follows the header branch like the rest of the Collections section (2026-10-02).
const ChequesDueTodayCard = () => {
  const today = dayjs().format("YYYY-MM-DD");
  const { selectedBranchId } = useBranchFilter();
  const { rows, isLoading } = useCollectionsRecords({
    paymentMethod: 4,
    chqDateFrom: today,
    chqDateTo: today,
    branchId: selectedBranchId ?? undefined,
  });

  if (isLoading) {
    return <div className="text-muted small mt-2">Loading cheques due today...</div>;
  }
  if (rows.length === 0) {
    return <div className="text-muted small mt-2">No cheques due today.</div>;
  }

  return (
    <div className="mt-2">
      <div className="text-muted small fw-semibold mb-1">Cheques Due Today</div>
      <div className="mini-summary-list">
        {rows.map((r) => (
          <div className="mini-summary-row" key={r.recordGuid}>
            <span className="mini-summary-row-icon">
              <CreditCard size={12} />
            </span>
            {/* Collections has no per-receipt detail route, so this opens the
                list on that receipt's own day and branch with the row itself
                highlighted - the same honest landing oneStopDrill.js uses. */}
            <Link
              className="mini-summary-row-label text-decoration-none"
              to={paths.collectionsFiltered({
                highlight: r.recordGuid,
                branchId: r.branchId,
                dateFrom: r.colectDate ? String(r.colectDate).slice(0, 10) : undefined,
                dateTo: r.colectDate ? String(r.colectDate).slice(0, 10) : undefined,
              })}
              title="Open this receipt in the Collections list"
            >
              {r.custName || "Unknown customer"}
            </Link>
            <span className="fw-semibold small">{money(r.amount)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChequesDueTodayCard;
